import {ShortcutListVo} from '../../common/shared/api/gateway/shortcut/ShortcutListVo.interface';
import {ShortcutList} from '../generated/types';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createShortcutItemList} from './ShortcutItemList';
import {createShortcutMenuItem} from './ShortcutMenuItem';

export function createShortcutList({
  section_promotion_banner,
  menu_list,
  shortcut_list,
}: ShortcutListVo): ShortcutList {
  return {
    promotionBanner:
      section_promotion_banner &&
      createPromotionBannerItem(section_promotion_banner),
    menuList: menu_list.map(createShortcutMenuItem),
    shortcutList: shortcut_list.map(createShortcutItemList),
  };
}
